import { TimelineItem } from '@ps/isp-web-component-library';
import { type MarketId, type SelectionId } from '@ps/isp-web-services-types';
import React from 'react';

import { Selection } from '@swf/sports/components';
import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';
import { useNormalisedMeetingBasedData } from '@swf/sports/hooks/useNormalisedMeetingBasedData';

import styles from './MeetingBasedPopularAccumulatorItem.scss';

interface Props {
  marketId: MarketId;
  selectionId: SelectionId;
}

const MeetingBasedPopularAccumulatorItem: React.FC<Props> = ({ marketId, selectionId }: Props) => {
  const { market, race } = useNormalisedMeetingBasedData({ marketId });

  const runner = market?.runners.find((runner) => runner.selectionId === selectionId);

  if (!market || !runner) return null;

  const { runnerName } = runner;

  return (
    <TimelineItem textWrap="balance">
      <div className={styles.item}>
        <div className={styles.singleDetails}>
          <span>
            <strong>{runnerName}</strong>{' '}
          </span>
          <span>{market.marketName}</span>
          <span className={styles.singleDetailsDate}>
            <FormattedDateTime date={race.startTime} /> {race.venue}
          </span>
        </div>
        <span className={styles.selection}>
          <Selection
            competitionId={market.competitionId}
            eventId={market.eventId}
            eventTypeId={market.eventTypeId}
            handicap={runner.handicap}
            isStartingPriceMarket={market.isStartingPriceMarket}
            key={runner.selectionId}
            legTypes={market.legTypes}
            marketId={market.marketId}
            marketStatus={market.marketStatus}
            marketType={market.marketType}
            odds={runner.winRunnerOdds}
            runnerResultType={runner.resultType}
            runnerStatus={runner.runnerStatus}
            selectionId={runner.selectionId}
            startTime={market.marketTime}
          />
        </span>
      </div>
    </TimelineItem>
  );
};

export default MeetingBasedPopularAccumulatorItem;
